import React from 'react';
import './PlayByPlayTab.scss';
import DynamicIframe from '../Common/DynamicIframe';

const PlayByPlayTab = ({ matchDetails }) => {
  const baseUrl =
    process.env.REACT_APP_API_PATH === 'https://dev.api.sketchbball.com'
      ? 'https://dev.stats.sketchbball.com/v2/embed/matches'
      : 'https://stats.sketchbball.com/v2/embed/matches';

  const match_id = matchDetails?.match_id;

  // Don't render if match_id is missing
  if (!match_id) {
    return null;
  }

  const playByPlay_query_params =
    'lang=en_US&isDebug=false&showMatchFlow=false&showShotFrequency=false&showScoreBoard=false&showTeamStat=false&showHeadToHead=false&showBoxScore=false&showPlayByPlay=true&showTitle=true&isFixed=true&background=f6f6f6&maxWidth=100%25&frequencyMode=all';
  const playByPlay_iframe_url = `${baseUrl}/${match_id}?${playByPlay_query_params}`;

  return (
    <div className='play-by-play-tab'>
      <div className='play-by-play-header'>
        <h3>Play by Play</h3>
        <p>Detailed sequence of events during the match</p>
      </div>

      <div className='play-by-play-container'>
        <DynamicIframe url={playByPlay_iframe_url} className='play-by-play-iframe' />
      </div>
    </div>
  );
};

export default PlayByPlayTab;
